export interface ILicense {
    id: number;
    bundle: ILicenseBundle;
    category: LicenseCategoryEnum;
    addOnProducts: IAddOnProductsModel[];
}

export interface IAddOnProductsModel {
    id: number;
    name: string;
    productCode: string;
}

export interface ILicenseBundle {
    id: number;
    name: string;
    externalName: string;
    products: IBundleProduct[];
}

interface IBundleProduct {
    id: number;
    name: string;
    productCode: string;
}

export enum LicenseCategoryEnum {
    Individual = 0,
    Site = 1,
    Organization = 2,
    Demo = 3,
    Unlimited = 4
}
